// Who may see / control the on-device-scan debug surface (console logging, the
// metrics strip, and the granular scan overrides in the uploader settings). ONLY
// andy@photohawk.io — ordinary users must never see scan chatter or the debug UI.
//
// The current-user email lives in React auth context, but the scan modules that need
// this gate (scanUi.ts, the worker config) are plain modules with no hooks — so an
// auth-aware effect (ScanAdminBinder) pushes the verdict here once, and everything
// reads it synchronously via isScanAdmin().
export const SCAN_ADMIN_EMAIL = "andy@photohawk.io";

let _isScanAdmin = false;

export const setScanAdmin = (isAdmin: boolean): void => {
  _isScanAdmin = !!isAdmin;
};

export const isScanAdmin = (): boolean => _isScanAdmin;

export const emailIsScanAdmin = (email?: string | null): boolean =>
  (email || "").trim().toLowerCase() === SCAN_ADMIN_EMAIL;
